import React from "react";
import loading from "../assets/loading.svg";

const Loading = () => (
  <div className="spinner">
    <img src={loading} alt="Loading" width="100px" heigth="100px"/>
  </div>
);

export default Loading;
